import { FadeUp, SectionHeading, MaskedLine } from "./Reveal";

export const Principal = () => (
  <section id="principal" className="px-6 md:px-12 py-28 md:py-40" data-testid="principal-section">
    <SectionHeading
      index="The Principal"
      title={
        <>
          Lonny L. Bradley{" "}
          <span className="block sm:inline text-sm sm:text-base lg:text-lg text-ash font-medium tracking-[0.15em]">
            AIA, NCARB, NOMA
          </span>
        </>
      }
      testId="principal-heading"
    />
    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-start">
      <FadeUp className="md:col-span-5 relative">
        <img
          src="/assets/headshot-1.jpg"
          alt="Lonny L. Bradley, Principal of ETMB Design Build"
          className="w-full aspect-[4/5] object-cover border border-white/15"
          data-testid="principal-headshot-main"
        />
        <img
          src="/assets/headshot-2.jpg"
          alt="Lonny L. Bradley"
          loading="lazy"
          className="hidden md:block mt-8 ml-auto w-44 lg:w-56 aspect-[3/4] object-cover border border-white/15"
          data-testid="principal-headshot-secondary"
        />
        <div className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase text-paper bg-[#19254D]/80 backdrop-blur-sm px-2 py-1">
          Principal
        </div>
      </FadeUp>

      <div className="md:col-span-6 md:col-start-7">
        <FadeUp>
          <h3 className="font-display text-3xl md:text-4xl lg:text-5xl uppercase font-bold tracking-tight leading-[1.02]" data-testid="principal-tagline">
            <MaskedLine>The name on the</MaskedLine>
            <MaskedLine delay={0.1}>drawings is the name</MaskedLine>
            <MaskedLine delay={0.2}>
              <span className="text-[#4361C2]">on the job site.</span>
            </MaskedLine>
          </h3>
        </FadeUp>
        <FadeUp delay={0.15}>
          <p className="mt-8 text-base md:text-lg font-light leading-relaxed text-paper" data-testid="principal-bio-1">
            Lonny L. Bradley leads ETMB Design Build as a working principal — not a name on a
            letterhead. From the Riley Residence second-story addition with JPC Architects to
            structural framing plans drawn under pressure, he carries every project personally
            from first sketch to final walkthrough.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-ash" data-testid="principal-bio-2">
            Design, engineering, and construction under one signature. When you call ETMB, you
            talk to the person accountable for the whole build — not a hand-off chain.
          </p>
        </FadeUp>
        <FadeUp delay={0.25}>
          <div className="mt-10 flex flex-wrap gap-x-12 gap-y-4 border-t border-white/15 pt-8 text-xs tracking-[0.25em] uppercase text-ash">
            <span data-testid="principal-fact-role">Principal — ETMB Design Build PLLC</span>
            <span data-testid="principal-fact-approach">Design + Build, One Team</span>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
